import api from './authService';

export const customReportsAPI = {
  getCatalog: () => api.get('/custom-reports/catalog'),
  preview: (body) => api.post('/custom-reports/preview', body),
  save: (body) => api.post('/custom-reports', body),
  list: (params) => api.get('/custom-reports', { params }),
  getById: (id) => api.get(`/custom-reports/${id}`),
  update: (id, body) => api.put(`/custom-reports/${id}`, body),
  remove: (id) => api.delete(`/custom-reports/${id}`),
  run: (id, body) => api.post(`/custom-reports/${id}/run`, body),
  duplicate: (id) => api.post(`/custom-reports/${id}/duplicate`),
  export: (body) => api.post('/custom-reports/export', body),
};

export default customReportsAPI;
